import loadable from '@loadable/component';
import React from 'react';

const LoadableComponent = loadable(() =>
  import(/* webpackChunkName: "shop-of-the-year" */ './banner')
);
const BannerLoader = props => <LoadableComponent {...props} />;

export default BannerLoader;
